/*global $ */
/*eslint no-undef: "error"*/

import './style.less'

import { minimiseLeftCanvasMenuOnSmallScreens } from './minMenu.js'

const pathNameClientRoutes = [
	{
		pathname: '/scfhs',
		clientShortName: 'scfhs',
	},
]

const LS_CLIENT_SHORTNAME = 'clientShortName'

const detectClientLoginRoute = () => {
	// Calculate if student is using a Client specific login route e.g.
	// https://learn.iheed.org/scfhs
	const pathname = window.location.pathname
	const loginRouteObj = pathNameClientRoutes.find(pathnameObj => pathnameObj.pathname === pathname)

	if (loginRouteObj) {
		// Browser is at route url which is also a Canvas 'page not found' page. Save
		// local storage client shortname
		window.localStorage.setItem(LS_CLIENT_SHORTNAME, loginRouteObj.clientShortName)

		// Redirect to login page
		window.location.replace(location.origin)
	} else {
		// Restore the content frame "page not found" elements, they were off as we don't want them seen on re-route screen.
		// Note: there are two #content elements, need to more specific and also use a class.

		$(
			"body:not([class*='context-']) #content.ic-Layout-contentMain > div:not([class]) > h2,\
      body:not([class*='context-']) #content.ic-Layout-contentMain > div:not([class]) > h2 + p,\
      body:not([class*='context-']) #content.ic-Layout-contentMain > div:not([class]) > h2 ~ a",
		).show()
	}
}

const adjustLoginScreen = () => {
	const clientLoginRouteShortName = window.localStorage.getItem(LS_CLIENT_SHORTNAME)
	if (clientLoginRouteShortName === 'scfhs') {
		$('.ic-Login-header').addClass('scfhs')
		$('body.ic-Login-Body').addClass('scfhs')
	} else {
		// show iheed logo on login screen
		$('.ic-Login-header__logo').show()
	}

	// show logo header on login screen
	$('.ic-Login-header').css('display', 'flex')
}

const showAllExceptCommonsButton = () => {
  // Remove Commons button only.
  $(".menu-item__text:contains('Commons')")
    .closest('li.ic-app-header__menu-list-item')
    .remove();

	// Show whole menu.
	// If this was done solely in JS and not also CSS,
	// the Commons button would flash briefly.
	const menu = document.querySelector('.ic-app-header__main-navigation ul#menu.ic-app-header__menu-list');
	if (menu) {
		menu.style.display = 'block';
	}
}

minimiseLeftCanvasMenuOnSmallScreens()
detectClientLoginRoute()
adjustLoginScreen()
showAllExceptCommonsButton()
